import validator from 'validator';

const isValidEmail = (value: string): boolean => {
  return validator.isEmail(value);
};

export default isValidEmail;
